import React from 'react';
export const authStateContext = React.createContext({
    isLoggedIn: false,
});
const { Provider } = authStateContext;
export const AuthStateProvider = Provider;
